module.exports = __webpack_public_path__ + "static/media/instruction_1.52e729b9.svg";